import { updateFormFilterFacets } from "../../Shared/Utilities/filterFacets";

const form = document.getElementById("event-list") as HTMLFormElement | null;

if (!form) {
  throw "Event list form missing";
}

const filterDropdowns = form.querySelectorAll<HTMLElement>("[data-filter-dropdown]");

filterDropdowns.forEach(filterDropdown => {
  const select = filterDropdown.querySelector("select");

  if (select) {
    select.addEventListener("change", async _ => {
      // Submit the form whenever a filter is updated
      form.requestSubmit();
    });
  }
});

htmx.on(form, "htmx:afterOnLoad", _ => {
  updateFormFilterFacets(form);
});
